const outlets = ["NAT GEO", "OUTSIDE", "CONDÉ NAST", "AFAR", "THE TRVL"];

const TrustStrip = () => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 px-6 pb-14 pt-1.5 font-mono text-[12px] tracking-[0.06em] text-muted-300 md:px-12">
      <span className="font-medium text-ink">Featured in</span>
      {outlets.map((o) => (
        <span key={o}>{o}</span>
      ))}
    </div>
  );
};

export default TrustStrip;
